<template>
<div id="access">
  <div class="schedule">
     <div class="name">
      <div class="name-tenyukai">{{ t.corp }}</div>
      <div class="name-nozomi">{{ t.name }}</div>
    </div>
    <div class="address">
      <div v-for="(a, i) in t.address" :key="i">{{ a }}</div>
    </div>
    <div class="tel" onclick="window.location.href='tel:0362606008'">
      <div><img src="../../assets/icon/icon_tel_hover_28x28@2x.png" alt="" width="20" height="20"></div>
      <div class="tel-number">03-6260-6008</div>
    </div>
    <div class="table" :class="{ en: $lang === 'en' }">
      <table>
        <tr>
          <td>{{ t.hours }}</td>
          <td v-for="d in t.days" :key="d">{{ d }}</td>
        </tr>
        <tr v-for="slot in ['10:00 ～ 13:30', '14:30 ～ 19:00']" :key="slot">
          <td>{{ slot }}</td>
          <td v-for="(o, i) in open" :key="i">{{ o ? '〇' : t.off }}</td>
        </tr>
      </table>
    </div>
    <div class="notice">{{ t.n1 }}</div>
    <div class="notice">{{ t.n2 }}</div>
    <!-- <div class="notice">※　火曜、木曜臨時内装工事による、臨時休診にします。診療日再開予定しております。</div> -->
    <!-- <div class="notice">※　月曜は、白川　太郎先生による「がんの自由診療」のみ実施しております。</div> -->
    <div class="notice">{{ t.n3 }}</div>
    <!-- <div class="notice">※ ９月２７日（終日）と１０月４日（午前中）は臨時休診とさせていただきます。ご迷惑をおかけし、誠に申し訳ございません。</div> 2025年の古い告知のため非表示 -->
    <!-- <div class="notice">※ 10月21日（火）から11月30日（日）まで、院内改装のため、対面での診療を一時休止いたします。​期間中は、オンライン遠隔診療のみご利用いただけます。</div> -->
    <div class="notice">{{ t.n4 }}</div>

  </div>

  <div class="map">
    <iframe :title="t.mapTitle" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1620.7302022458769!2d139.77382708041415!3d35.66566389811144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601889623b873a13%3A0x1c21f5e80c1e7f9d!2z44CSMTA0LTAwNDUg5p2x5Lqs6YO95Lit5aSu5Yy656-J5Zyw77yX5LiB55uu77yR77yR4oiS77yVIOS4remKgOODmeODq-evieWcsOODnuODs-OCt-OCquODsyAy6ZqO!5e0!3m2!1sja!2sjp!4v1633341603803!5m2!1sja!2sjp" width="100%" height="400" style="border:2px solid #62b6e2;" allowfullscreen="" loading="lazy"></iframe>
  </div>

  <div v-if="showButtons" class="info">
    <div class="btn-line" @click="goHref('https://lin.ee/AqbMjHK')">
      <div class="btn-icon"></div>
      <div class="btn-text">
        <div>{{ t.line }}</div>
        <div class="sub-text">{{ t.lineSub }}</div>
      </div>
    </div>
    <div class="btn-online" @click="goHref('https://connect.kireipass.jp/clinics/tenyukai-hope/web-order/menus')">
      <div class="btn-icon"></div>
      <div class="btn-text">
        <div>{{ t.web }}</div>
        <!-- <div class="sub-text">オンライン診療はこちらから</div> -->
        <div class="sub-text">{{ t.webSub }}</div>
      </div>
    </div>
    <div class="btn-online" style="margin-top: 14px;" @click="goTo('/sending')">
      <div class="btn-icon-mail"></div>
      <div class="btn-text">{{ t.contact }}</div>
    </div>
  </div>
</div>
</template>

<script>
import ACCESS_T from '@/i18n/access'

export default {
  name: "MAccess",
  props: {
    // 下部の LINE予約／WEB予約／お問合せ ボタンを表示するか
    showButtons: { type: Boolean, default: true },
  },
  data() {
    // 月〜日の診療あり（水・日は休診）
    return { open: [true, true, false, true, true, true, false] }
  },
  computed: {
    t() {
      const t = ACCESS_T[this.$lang] || ACCESS_T.ja
      return this.$lang === 'ja' ? { ...t, n4: '※　中国語対応可能。' } : t
    },
  },
  methods: {
    goTo(page) {
      this.$router.push(this.$lp(`${page}`))
    },
    goHref(path) {
      window.location.href = path;
    }
  }
}
</script>

<style scoped>
#access {
  padding: 30px 20px;
}
/* 病院情報 */
.schedule .name-tenyukai {
  color: #9E9E9E;
  font-size: 10px;
  font-weight: bold;
}
.schedule .name-nozomi {
  color: #62B6E2;
  font-size: 16px;
  font-weight: bold;
}
.schedule .address {
  font-size: 12px;
  margin-top: 10px;
}
.schedule .tel {
  align-items: flex-start;
  display: flex;
  margin-top: 14px;
}
.schedule .tel .tel-number {
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}
/* 診療時間 */
.schedule .table table {
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 12px;
  margin-top: 10px;
  width: 100%;
}
.schedule .table table tr:first-child {
  background-color: #f0f0f0;
}
.schedule .table table td {
  border: 1px solid #cccccc;
  text-align: center;
  padding: 8px 12px;
}
/* 英語は曜日（Mon など）が長いので、左右の余白を詰めて画面に収める */
.schedule .table.en table td {
  padding: 8px 3px;
}
.schedule .notice {
  font-size: 12px;
  margin-top: 10px;
}
/* MAP */
.map {
  margin-top: 20px;
}
/* ボタン */
.info {
  margin-top: 20px;
}
.info .btn-line {
  align-items: center;
  background-color: #62B6E2;
  border: 2px solid #62B6E2;
  border-radius: 5px;
  box-shadow: 0 2px 4px #CCCCCC;
  cursor: pointer;
  display: flex;
  padding: 8px 16px;
  transition: 50ms;
  height: 40px;
}
.info .btn-line .btn-icon{
  height: 36px;
  width: 36px;
  background-image: url("../../assets/icon/icon_calendar_36x36@2x.png");
  background-size: 100%;
  transition: 50ms;
}

.info .btn-line .btn-icon-mail{
  height: 36px;
  width: 36px;
  background-image: url("../../assets/icon/icon_mail_36x36@2x.png");
  background-size: 100%;
  transition: 50ms;
}

.info .btn-line:active{
  background-color: #ffffff;
}

.info .btn-line:active .btn-icon{
  background-image: url("../../assets/icon/icon_calendar_hover_36x36@2x.png");
}

.info .btn-line:active .btn-icon-mail{
  background-image: url("../../assets/icon/icon_mail_hover_36x36@2x.png");
}

.info .btn-line:active .btn-text{
  color: #62B6E2;
  font-size: 14px;
}

.info .btn-line:active .btn-text .sub-text{
  color: #62B6E2;
  font-size: 10px;
}

.info .btn-online {
  align-items: center;
  background-color: #62B6E2;
  border: 2px solid #62B6E2;
  border-radius: 5px;
  box-shadow: 0 2px 4px #CCCCCC;
  cursor: pointer;
  display: flex;
  padding: 8px 16px;
  transition: 50ms;
  height: 40px;
}
.info .btn-online .btn-icon{
  height: 36px;
  width: 36px;
  background-image: url("../../assets/icon/icon_calendar_36x36@2x.png");
  background-size: 100%;
  transition: 50ms;
}

.info .btn-online .btn-icon-mail{
  height: 36px;
  width: 36px;
  background-image: url("../../assets/icon/icon_mail_36x36@2x.png");
  background-size: 100%;
  transition: 50ms;
}

.info .btn-online:active{
  background-color: #ffffff;
}

.info .btn-online:active .btn-icon{
  background-image: url("../../assets/icon/icon_calendar_hover_36x36@2x.png");
}

.info .btn-online:active .btn-icon-mail{
  background-image: url("../../assets/icon/icon_mail_hover_36x36@2x.png");
}

.info .btn-online:active .btn-text{
  color: #62B6E2;
  font-size: 14px;
}

.info .btn-online:active .btn-text .sub-text{
  color: #62B6E2;
  font-size: 10px;
}

.info .btn-mail {
  align-items: center;
  background-color: #FFFFFF;
  border: 2px solid #62B6E2;
  border-radius: 5px;
  box-shadow: 0 2px 4px #CCCCCC;
  cursor: pointer;
  display: flex;
  padding: 8px 16px;
  margin-top: 14px;
  height: 40px;
}

.info .btn-text {
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
  transition: 50ms;
}
.info .btn-text .sub-text {
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  transition: 50ms;
}
</style>
